import 'react-perfect-scrollbar/dist/css/styles.css';
import 'nprogress/nprogress.css';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { StyledEngineProvider } from '@mui/material';
import { SnackbarUtilsConfigurator } from 'utils/snackbarUtilsConfigurator';

import App from './App';
import { AuthProvider } from './contexts/JWTContext';
import { SettingsProvider } from './contexts/SettingsContext';
import React from 'react';
import './main.css';
import { SnackbarProvider } from 'notistack';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <SettingsProvider>
        <BrowserRouter>
          <AuthProvider>
            <SnackbarProvider
              maxSnack={3}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
              <SnackbarUtilsConfigurator />
              <App />
            </SnackbarProvider>
          </AuthProvider>
        </BrowserRouter>
      </SettingsProvider>
    </StyledEngineProvider>
  </React.StrictMode>
);
